const directions = [0, 45, 90, 135, 180, -45, -90, -135];

export default directions;
